/* src/app/modules/print-cards/components/cut-lines/print-card-left-cut-lines/print-card-left-cut-lines.component.scss */
:host {
  flex: 1;
  display: flex;
  z-index: 1;
}
.left-cut-lines {
  position: relative;
  width: 100%;
  max-width: 2rem;
  display: flex;
  flex-direction: column;
}
.left-cut-lines.extended {
  max-width: none;
}
.left-cut-lines * {
  box-sizing: border-box;
}
.left-cut-lines .spacer {
  align-self: center;
  font-size: 1rem;
  text-align: center;
  text-transform: uppercase;
}
.left-cut-lines .dividing-sliver-container {
  position: relative;
}
.left-cut-lines .dividing-sliver-container .dividing-sliver {
  position: relative;
  height: 100%;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.left-cut-lines .dividing-sliver-container .dividing-sliver-vertical-top-line {
  position: absolute;
  align-self: center;
  border-right: 1px solid black;
}
.left-cut-lines .dividing-sliver-container .dividing-sliver-vertical-middle-line {
  position: absolute;
  align-self: center;
  border-right: 1px solid black;
}
.left-cut-lines .dividing-sliver-container .dividing-sliver-vertical-bottom-line {
  position: absolute;
  align-self: center;
  border-right: 1px solid black;
}
/*# sourceMappingURL=print-card-left-cut-lines.component.css.map */
